/**
 * Identifies the type of adjustment.
 * tag: 334
 * @readonly
 * @enum {number} (int)
 */
export enum Adjustment {
  /** Cancel */
  Cancel = 1,
  /** Error */
  Error = 2,
  /** Correction */
  Correction = 3,
}
